import { Flex } from '@radix-ui/themes';
import EnvironmentBadge from '@/components/EnvironmentBadge';

export default function NoLayout({ children }) {
  return (
    <>
      <Flex className="fixed m-2 right-0" justify="center">
        <EnvironmentBadge />
      </Flex>

      {children}
    </>
  );
}
